import React, { type FC, memo, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@heroui/react";

import { type AssistantActions } from "@dms/components/DmsSortAssistant/useAssistantActions";
import { DmsType } from "@domain/models/dms";

import { ANSWER_CLASS, AnswerButton, LaterButton, QUESTION_CLASS, type Run } from "./panelShared";

type Props = {
    documentId: string;
    isPending: boolean;
    run: Run;
    onAdvance: () => void;
    onLater?: () => void;
    moveTo: AssistantActions["moveTo"];
};

const WHERE_TARGETS: { type: DmsType; labelId: string }[] = [
    { type: DmsType.KB, labelId: "app.dms.sortAssistant.toKasse" },
    { type: DmsType.Bank, labelId: "app.dms.sortAssistant.toBank" },
    { type: DmsType.ER, labelId: "app.dms.sortAssistant.toEr" },
];

const WherePanelImpl: FC<Props> = ({ documentId, isPending, run, onAdvance, onLater, moveTo }) => {
    const handleMove = useCallback(
        (type: DmsType) => run(() => moveTo(documentId, type, null)),
        [documentId, moveTo, run],
    );
    return (
        <div className="flex flex-col gap-3">
            <h3 className={QUESTION_CLASS}>
                <FormattedMessage id="app.dms.sortAssistant.whereQuestion" />
            </h3>
            {WHERE_TARGETS.map(({ type, labelId }) => (
                <AnswerButton key={type} value={type} labelId={labelId} isPending={isPending} onSelect={handleMove} />
            ))}
            <Button className={ANSWER_CLASS} variant="outline" isDisabled={isPending} onPress={onAdvance}>
                <FormattedMessage id="app.dms.sortAssistant.stay" />
            </Button>
            <LaterButton isPending={isPending} onLater={onLater} />
        </div>
    );
};

export const WherePanel = memo(WherePanelImpl);
